export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "Envoyé avec succès",
      error: "Erreur d'envoi",
      notConfigured: "Non configuré",
      pending: "Envoi en attente",
    },
    errorNoInfo: "Erreur (aucun détail)",
  },
  msgPolice: {
    title: "Information",
    pendingSyncText:
      "Les données du check-in sont en attente de synchronisation ; elles seront envoyées aux autorités locales le jour même de l'arrivée du voyageur dans l'hébergement.",
    entryDateLabel: "Date d'arrivée :",
    syncedText:
      "Les données du voyageur {name} ont été synchronisées avec succès auprès des autorités locales.",
    syncDateLabel: "Date de synchronisation :",
    errorText:
      "Pour des raisons externes, la synchronisation avec les autorités locales n'a pas pu être effectuée.",
    close: "Fermer",
  },
};
